<template>
  <div class="wrap">
    <div class="main-wrap opportunity-detail">
      <!-- 吸顶：导航 + 标题 + 切换面包屑（仅本页），固定不滚动；top 动态等于固定头部 .head-wrap 的高度 -->
      <div class="detail-sticky-head" ref="stickyHead" :style="{ top: headHeight + 'px' }">
        <!-- 导航 -->
        <div class="order-navigation">
          <router-link
            class="text1"
            to="/catalogue"
          >{{L.home}}</router-link>
          <span class="line">/</span>
          <router-link
            class="text1"
            to="/opportunity"
          >My Opportunities</router-link>
          <span class="line">/</span>
          <span class="text2" v-if="isNew">New</span>
          <span class="text2" v-if="!isNew">{{ form.oppNo }}</span>
        </div>
        <!-- 标题 -->
        <div class="my-orders-title">
          <div class="title-left">
            <span>{{ pageTitle }}</span>
            <span class="draft-number" v-if="!isNew">{{ form.oppNo }}</span>
          </div>
          <div class="title-right" v-if="!isNew && form.status==10">
            <div class="btn-with-bg" @click="handleRelease">
              <span class="iconfont icon-release">&#xe747;</span>
              <span>Release Opportunity</span>
            </div>
            <div class="btn-with-icon-with-bg" @click="handleDeleteOpp">
              <span class="iconfont icon-delete">&#xec7b;</span>
            </div>
          </div>
        </div>
        <!-- 分区切换面包屑：General Information 与 Product List 为固定项(不可关闭)；打开的产品详情为动态项(可关闭)，文字取 model、以 opportunityLineId 为唯一 key -->
        <div class="section-breadcrumb">
          <span
            class="crumb-item"
            :class="{ active: activeTab === 'general' }"
            @click="switchTab('general')"
          >General Information</span>
          <span
            class="crumb-item"
            :class="{ active: activeTab === 'product' }"
            @click="switchTab('product')"
          >Product List</span>
          <span
            class="crumb-item crumb-closable"
            v-for="tab in productTabs"
            :key="tab.key"
            :class="{ active: activeTab === tab.key }"
            @click="switchToProductTab(tab.key)"
          >{{ tab.label }}<i class="crumb-close" @click.stop="closeProductTab(tab.key)">&times;</i></span>
        </div>
      </div>

      <!-- General Data：左右布局，高度固定为视口可用高，左(标题固定+表单滚动)与右(标题固定+附件滚动)各自独立滚动 -->
      <div class="general-data-wrap" ref="generalData" v-show="activeTab === 'general'" :style="{ height: contentHeight + 'px' }" v-loading="allLoading" element-loading-background="rgba(255,255,255,0.5)">
        <div class="general-data-left">
          <div class="line-title" ref="lineTitle">
            <span class="text">General Information</span>
            <div class="btn-group">
              <div class="continuous-btn-no-bg">
                <div class="btn" @click="handleSubmit" v-if="form.status==10">Save</div>
              </div>
              <div class="btn-with-icon-with-bg" @click="handleRefreshDetail" v-if="!isNew">
                <span class="iconfont icon-refresh">&#xe611;</span>
              </div>
            </div>
            
          </div>
          <el-form class="form" :model="form" :rules="rules" ref="formGeneral">
            <div class="form-wrap">
              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">Created Date</div>
                  <el-form-item prop="createTime">
                    <el-date-picker
                      disabled
                      size="mini"
                      v-model="form.createTime"
                      class="inp"
                      value-format="yyyy-MM-dd"
                      format="dd-MM-yyyy"
                      type="date">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title"><span class="asterisk">*</span>Opportunity Name</div>
                  <el-form-item prop="oppName">
                    <el-input class="inp" size="mini" :autosize="{ minRows: 1}" type="textarea" v-model="form.oppName"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">Opportunity No.</div>
                  <el-form-item prop="oppNo">
                    <el-input disabled size="mini" v-model="form.oppNo" class="inp"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title"><span class="asterisk">*</span>Project Type</div>
                  <el-form-item prop="projectType">
                    <el-select size="mini" v-model="form.projectType" class="inp" popper-class="opp-select-popper" placeholder="Please select">
                      <el-option
                        v-for="item in enumerate.oppProjectType"
                        :key="item.code"
                        :label="item.nameEn"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title"><span class="asterisk">*</span>One-off Project</div>
                  <el-form-item prop="oneTimeFlag">
                    <el-select size="mini" v-model="form.oneTimeFlag" class="inp" popper-class="opp-select-popper" placeholder="Please select">
                      <el-option
                        v-for="item in enumerate.oppOneTime"
                        :key="item.code"
                        :label="item.nameEn"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">Stage</div>
                  <el-form-item prop="stage">
                    <el-select disabled size="mini" v-model="form.stage" class="inp" placeholder="">
                      <el-option
                        v-for="item in enumerate.oppStage"
                        :key="item.code"
                        :label="item.nameEn"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">Status</div>
                  <el-form-item prop="status">
                    <el-select :class="getOppStatusColor(form.status)" disabled size="mini" v-model="form.status" class="inp" placeholder="">
                      <el-option
                        v-for="item in enumerate.oppStatus"
                        :key="item.code"
                        :label="item.nameEn"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">OU</div>
                  <el-form-item prop="ou">
                    <el-input disabled size="mini" v-model="form.ou" class="inp"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">Ordering Customer</div>
                  <el-form-item prop="buyingCustomerName">
                    <el-input disabled class="inp" size="mini" :autosize="{ minRows: 1}" type="textarea" v-model="form.buyingCustomerName"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">Ordering Customer No.</div>
                  <el-form-item prop="buyingCustomerNo">
                    <el-input disabled size="mini" v-model="form.buyingCustomerNo" class="inp"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title"><span class="asterisk">*</span>End Customer</div>
                  <el-form-item prop="endCustomerName">
                    <div class="search-wrap">
                      <el-input class="inp not-allow" :autosize="{ minRows: 1}" type="textarea" size="mini" readonly v-model="form.endCustomerName"></el-input>
                      <span class="iconfont icon-search" @click="showEndCustomer">&#xe622;</span>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">End Customer No.</div>
                  <el-form-item prop="endCustomerId">
                    <el-input disabled class="inp" size="mini" v-model="form.endCustomerId"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap" v-if="form.status!=10">
                <div class="suqare">
                  <div class="title">Salesperson Email</div>
                  <el-form-item prop="salesEmail">
                    <el-input disabled class="inp" size="mini" :autosize="{ minRows: 1}" type="textarea" v-model="form.salesEmail"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap" v-if="form.status!=10">
                <div class="suqare">
                  <div class="title">Currency</div>
                  <el-form-item prop="currency">
                    <el-input disabled size="mini" v-model="form.currency" class="inp"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap" v-if="form.status!=10">
                <div class="suqare">
                  <div class="title">Incoterms</div>
                  <el-form-item prop="tradeTerm">
                    <el-input disabled size="mini" v-model="form.tradeTerm" class="inp"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title"><span class="asterisk">*</span>Application Type</div>
                  <el-form-item prop="appType">
                    <el-select size="mini" v-model="form.appType" class="inp" popper-class="opp-select-popper" placeholder="Please select" filterable>
                      <el-option
                        v-for="item in enumerate.oppApplicationType"
                        :key="item.code"
                        :label="item.nameEn"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title"><span class="asterisk">*</span>Win Probability</div>
                  <el-form-item prop="winRate">
                    <el-select size="mini" v-model="form.winRate" class="inp" popper-class="opp-select-popper" placeholder="Please select" filterable>
                      <el-option
                        v-for="item in enumerate.oppWinProbability"
                        :key="item.code"
                        :label="item.nameEn"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <!-- 占位的 -->
              <div class="inline-wrap" v-if="form.status!=10">
                <div class="suqare">
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">Est. Annual Rev. (Excl. Tax)</div>
                  <el-form-item prop="annualRevenue">
                    <el-input-number
                      disabled
                      size="mini"
                      :controls="false"
                      :precision="2"
                      v-model="form.annualRevenue"
                      class="inp">
                    </el-input-number>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap">
                <div class="suqare">
                  <div class="title">Est. Proj Period Rev (Excl. Tax)</div>
                  <el-form-item prop="projectRevenue">
                    <el-input-number
                      disabled
                      size="mini"
                      :controls="false"
                      :precision="2"
                      v-model="form.projectRevenue"
                      class="inp">
                    </el-input-number>
                  </el-form-item>
                </div>
              </div>

              

              <div class="inline-wrap inline-wrap-long">
                <div class="suqare">
                  <div class="title">Competitor Information</div>
                  <el-form-item prop="competitorInfo">
                    <el-input
                      :autosize="{ minRows: 1 }"
                      type="textarea"
                      v-model="form.competitorInfo">
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="inline-wrap inline-wrap-long">
                <div class="suqare">
                  <div class="title">Other Project Remarks</div>
                  <el-form-item prop="otherRemark">
                    <el-input
                      :autosize="{ minRows: 1 }"
                      type="textarea"
                      v-model="form.otherRemark">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <!-- 附件列表（右侧框）：高度随左侧拉伸至等高，标题栏固定、文件列表区内部滚动；接口待接，暂为占位 -->
        <div class="attachment-box">
          <div class="attachment-inner">
            <div class="attachment-title" :style="titleBarHeight ? { height: titleBarHeight + 'px' } : {}">
              <div class="title-main">
                <span class="title-text">Attachments</span>
                <span class="count-badge" v-if="fileList.length">{{ fileList.length }}</span>
              </div>
              <div class="btn-group" v-if="!isNew">
                <div class="continuous-btn-with-bg">
                  <el-upload
                    v-if="form.status==10"
                    :action="uploadApi"
                    :multiple="true"
                    :show-file-list="false"
                    :http-request="handleUpload">
                    <div class="btn btn-icon">
                      <span class="iconfont icon-upload">&#xe65c;</span>
                    </div>
                  </el-upload>
                  <div class="btn btn-icon" @click="handleRefreshFile">
                    <span class="iconfont icon-refresh">&#xe611;</span>
                  </div>
                </div>
                
              </div>
            </div>
            <div class="attachment-scroll">
              <template v-if="fileList.length">
                <div class="file-wrap" v-for="(item,index) in fileList" :key="index">
                  <div class="file-icon-wrap" :class="'ft-' + fileType(fileSuffix(item.fileName))">
                    <span class="iconfont">{{ iconChar(fileType(fileSuffix(item.fileName))) }}</span>
                  </div>
                  <div class="left-file-name">
                    <div class="file-name" @click="handleDownloadFile(item)">{{ item.fileName }}</div>
                    <div class="detail-info">{{ formatDateTime(item.createTime) }} • {{ item.fileSizeText }}</div>
                  </div>
                  <div class="right-delete" @click="handleDeleteFile(item)" v-if="form.status==10">
                    <span class="iconfont ft-delete">&#xec7b;</span>
                  </div>
                </div>
              </template>
              <div class="attachment-empty" v-else>{{L.noData}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Product List（已抽离为独立组件，v-model 双向绑定产品数据） -->
      <ProductList
        v-loading="allLoading" element-loading-background="rgba(255,255,255,0.5)"
        v-show="activeTab === 'product'"
        v-model="productList"
        :product-type-options="enumerate.oppProductType"
        :editable="!isNew"
        :can-add-item="form.status==10"
        @open-detail="openProductDetail"
        @refresh="getProductList"
      />

      <!-- Product Detail（页面式，替代原 ProductDialog 弹窗）：可打开多个，各自以 opportunityLineId 为唯一 key，样式同 General Information、无附件 -->
      <ProductDetail
        v-for="tab in productTabs"
        v-show="activeTab === tab.key"
        :key="tab.key"
        :data="tab.data"
        :opp-no="form.oppNo"
        :product-type-options="enumerate.oppProductType"
        :can-edit="form.status==10"
        @saved="onProductSaved(tab, $event)"
        @deleted="onProductDeleted(tab)"
      />

      <!-- End Customer 选择弹窗：勾选后回填 End Customer No./Name -->
      <EndCustomer ref="EndCustomer" @select="getEndCustomerFromDialog" />
      <ReleaseError ref="ReleaseError" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ProductList from './ProductList'
import ProductDetail from './ProductDetail'
import ReleaseError from './ReleaseError'
import EndCustomer from '@/components/EndCustomer'
import selectMixin from '@/mixins/selectMixins'
import {postAction, getAction, postFormAction, downFileGet} from '@/api/tool'
import {api_opp_new_head, api_opp_update_head, api_order_confirm_download,api_opp_detail_head,api_opp_upload_file,api_opp_file_list,api_opp_delete_file,api_opp_case_product_list,api_opp_release_head,api_opp_delete_head} from '@/api/api'

export default {
  name:'OpportunityDetail',
  mixins:[selectMixin],
  components:{
    ProductList,
    ProductDetail,
    EndCustomer,
    ReleaseError
  },
  data(){
    return {
      allLoading:false, //整页 loading：保存、加载详情时置真（模板 v-loading="allLoading"）
      oppId:'', //路由参数：New 表示新增，否则为商机编号（编辑）
      headHeight:0, //固定头部 .head-wrap 的高度，供本页吸顶导航/标题的 top 使用
      contentHeight:0, //.general-data-wrap 的固定高度（视口可用高），由 handleResize 动态计算，使左右两列内部滚动而整页不滚动
      titleBarHeight:0, //左侧 General Information 标题栏高度，用于让右侧 Attachments 标题栏等高
      activeTab:'general', //当前展示的分区：general=General Information(含附件)，product=Product List，其余为已打开的产品详情 tab.key
      productTabs:[], //已打开的产品详情页签：[{ key, label, data }]；key 取 opportunityLineId(新增用临时 key)，label 取 model，可关闭
      form:{
        createTime:'',
        oppName:'',
        oppNo:'',
        projectType:'',
        oneTimeFlag:'',
        stage:'',
        status:'',
        ou:'',
        buyingCustomerNo:'',
        buyingCustomerName:'',
        endCustomerId:'',
        endCustomerName:'',
        salesEmail:'',
        currency:'',
        tradeTerm:'',
        appType:'',
        winRate:'',
        annualRevenue:undefined,
        projectRevenue:undefined,
        competitorInfo:'',
        otherRemark:''
      },
      fileList:[],
      productList:[], //产品列表（本地维护）
      rules:{
        oppName:[
          {required:true, message:'Complete this field.', trigger:'change'}
        ],
        projectType:[
          {required:true, message:'Complete this field.', trigger:'change'}
        ],
        oneTimeFlag:[
          {required:true, message:'Complete this field.', trigger:'change'}
        ],
        endCustomerName:[
          {required:true, message:'Complete this field.', trigger:'blur'}
        ],
        appType:[
          {required:true, message:'Complete this field.', trigger:'change'}
        ],
        winRate:[
          {required:true, message:'Complete this field.', trigger:'change'}
        ]
      }
    }
  },
  computed:{
    /* 是否为新增 */
    isNew(){
      return !this.oppId || this.oppId === 'New'
    },
    uploadApi(){
      return api_opp_upload_file
    },
    /* 页面标题 */
    pageTitle(){
      return this.isNew ? 'New Opportunity' : 'Opportunity'
    }
  },
  watch:{
    /* 路由 query.tab 变化（如浏览器前进/后退）时同步当前分区 */
    '$route.query.tab'(){
      this.syncTabFromRoute()
    },
    /* 新增模式下 userInfo 异步到达后回填 ou / Ordering Customer No. & Name（修复刷新页面时 created 早于接口返回导致的空值） */
    '$store.state.userInfo'(){
      if(this.isNew){
        this.applyUserInfoDefaults()
      }
    },
    /* 产品行变化时实时重算 Estimated Annual/Project Revenue（所有行 qty × Avg. Unit Price(Exc. Tax) 之和） */
    productList:{
      handler(list){
        this.recalcRevenue(list)
      },
      deep:true
    }
  },
  methods:{
    handleRefreshDetail(){
      this.getDetail(this.oppId)
    },
    handleRefreshFile(){
      this.getFileList()
    },
    /* 实时重算营收（数据源为产品列表 productList）：
       Estimated Annual Revenue = Σ(annualQty × priceWithoutTax)；Estimated Project Revenue = Σ(projectQty × priceWithoutTax)；
       结果保留 2 位小数（同字段 :precision="2"）。无产品行时和为 0。 */
    recalcRevenue(list){
      let rows = Array.isArray(list) ? list : []
      let annual = 0
      let project = 0
      rows.forEach(r=>{
        let price = Number(r.priceWithoutTax) || 0
        annual += (Number(r.annualQty) || 0) * price
        project += (Number(r.projectQty) || 0) * price
      })
      this.form.annualRevenue = Math.round(annual * 100) / 100
      this.form.projectRevenue = Math.round(project * 100) / 100
    },
    /* 取文件后缀（小写），参考 cqm2 mainMixins.fileSuffix */
    fileSuffix(name){
      if(!name){
        return ''
      }
      let arr = name.split('.')
      return (arr[arr.length - 1] || '').toLowerCase()
    },
    /* 后缀 -> 文件类型，参考 cqm2 mainMixins.fileType */
    fileType(type){
      let arr1 = ['txt']
      let arr2 = ['pdf']
      let arr3 = ['doc','docx']
      let arr4 = ['xls','xlsx']
      let arr5 = ['ppt','pptx']
      let arr6 = ['jpg','jpeg','png','gif','bpm','tiff','tif','svg','webp']
      let arr7 = ['zip','rar','7z','tar','gz']
      let arr8 = ['mp3','wav','flac','aac','wma','m4a','mp4','avi','mov','wmv','flv','mkv','webm']
      if(arr1.includes(type)){ return 'txt' }
      if(arr2.includes(type)){ return 'pdf' }
      if(arr3.includes(type)){ return 'word' }
      if(arr4.includes(type)){ return 'excel' }
      if(arr5.includes(type)){ return 'ppt' }
      if(arr6.includes(type)){ return 'jpg' }
      if(arr7.includes(type)){ return 'zip' }
      if(arr8.includes(type)){ return 'mp3' }
      return 'other'
    },
    /* 文件类型 -> iconfont 字形字符（unicode 与 cqm2 General.vue 右侧附件一致） */
    iconChar(type){
      let map = {
        txt:'\ue610',
        pdf:'\ue60a',
        word:'\ue885',
        excel:'\ue602',
        ppt:'\ue63a',
        jpg:'\ue70e',
        zip:'\ue859',
        mp3:'\ue6f6',
        other:'\ue68f'
      }
      return map[type] || map.other
    },
    handleUpload(file){
      //限制文件大小为10MB
      const maxSize = 10 * 1024 * 1024; // bytes
      if(file.file.size>maxSize){
        this.$message.warning('A single file cannot exceed 10MB.')
        return
      }
      let params = {
        oppNo:this.oppId,
        file:file.file,
      }
      this.allLoading=true
      postFormAction(api_opp_upload_file,params).then(()=>{
        this.allLoading=false
        this.$message.success('Upload successful.')
        this.getFileList()
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 下载附件（接口待接） */
    handleDownloadFile(item){
      let params = {
        filezIds:item.filezId
      }
      this.allLoading=true
      getAction(api_order_confirm_download,params).then(res=>{
        res.forEach((val)=>{
          let url='/'+val.split(Vue.config.YUNPAN_URL)[1]
          url=url.replace('PDF?','pdf?')
          downFileGet(url).then(res=>{
            this.allLoading=false
            this.downloadFile(res, 0, item.fileName)
          })
        })
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 删除附件：确认框提示 -> 调 api_opp_delete_file(post) -> 刷新列表 */
    handleDeleteFile(item){
      this.$confirm(`Are you sure to delete the file 【${item.fileName}】?`,'Delete File',{
        confirmButtonText:this.promptConfirmBtn,
        cancelButtonText:this.propmtCancelBtn,
        type:'warning',
        closeOnClickModal:false
      }).then(()=>{
        let params = {
          fileId:item.fileId,
          oppNo:this.oppId
        }
        this.allLoading=true
        postAction(api_opp_delete_file,params).then(()=>{
          this.allLoading=false
          this.$message.success('Delete successfully')
          this.getFileList()
        }).catch(()=>{
          this.allLoading=false
        })
      }).catch(()=>{})
    },
    /* Release Opportunity：POST api_opp_release_head，oppNo 拼在 URL query；成功后提示并刷新详情以反映最新状态 */
    handleRelease(){
      let oppNo = this.form.oppNo || this.oppId
      if(!oppNo){
        return
      }
      this.$confirm(`Are you sure to release opportunity 【${this.form.oppName}】?`,'Release Opportunity',{
        confirmButtonText:this.promptConfirmBtn,
        cancelButtonText:this.propmtCancelBtn,
        type:'warning',
        closeOnClickModal:false
      }).then(()=>{
        this.allLoading=true
        postAction(api_opp_release_head + '?oppNo=' + encodeURIComponent(oppNo), {}).then(res=>{
          if(!res.success){
            this.$refs.ReleaseError.open(res.failedLines)
          }else{
            this.$message.success(this.L.operateSuccess)
          }
          this.allLoading=false
          this.getDetail(oppNo)
        }).catch(()=>{
          this.allLoading=false
        })
      }).catch(()=>{})
    },
    /* 删除商机：POST api_opp_delete_head，oppNo 拼在 URL query；成功后提示并返回商机列表 */
    handleDeleteOpp(){
      let oppNo = this.form.oppNo || this.oppId
      if(!oppNo){
        return
      }
      this.$confirm(`Are you sure to delete opportunity 【${this.form.oppName}】?`,'Delete Opportunity',{
        confirmButtonText:this.promptConfirmBtn,
        cancelButtonText:this.propmtCancelBtn,
        type:'warning',
        closeOnClickModal:false
      }).then(()=>{
        this.allLoading=true
        postAction(api_opp_delete_head + '?oppNo=' + encodeURIComponent(oppNo), {}).then(()=>{
          this.allLoading=false
          this.$message.success(this.L.operateSuccess)
          this.$router.push({ name:'Opportunity' }).catch(()=>{})
        }).catch(()=>{
          this.allLoading=false
        })
      }).catch(()=>{})
    },
    getFileList(){
      let params = {
        oppNo:this.oppId
      }
      this.allLoading=true
      getAction(api_opp_file_list,params).then(res=>{
        this.fileList = res || []
        this.allLoading=false
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 新增时的默认值 */
    setNewDefault(){
      //Created Date 新增时默认当天（格式同 date-picker 的 value-format: yyyy-MM-dd）
      let now = new Date()
      let y = now.getFullYear()
      let m = String(now.getMonth()+1).padStart(2,'0')
      let d = String(now.getDate()).padStart(2,'0')
      this.form.createTime = `${y}-${m}-${d}`
      this.form.stage='10'
      this.form.status='10'
      //ou / Ordering Customer No. & Name 的默认值统一走 applyUserInfoDefaults（userInfo 可能异步到达，另见 watch）
      this.applyUserInfoDefaults()
    },
    /* 从 store.userInfo 回填仅新增时用的默认值：ou、Ordering Customer No./Name。
       userInfo 由 App.vue 的 getUserInfo() 异步写入，刷新页面时 created→setNewDefault 早于接口返回、userInfo 还是 {}，
       故此处首次尝试 + watch '$store.state.userInfo' 到达后补填；这几个字段均 disabled，用户不会手改，重复回填安全。
       No. 与 Name 必须成对取（customerAccountNo→customerName，ledCustomerAccountNo→ledCustomerAccountName），不交叉。 */
    applyUserInfoDefaults(){
      let userInfo = this.$store.state.userInfo || {}
      this.form.ou = userInfo.ou || ''
      if(userInfo.customerAccountNo){
        this.form.buyingCustomerNo = userInfo.customerAccountNo
        this.form.buyingCustomerName = userInfo.customerName || ''
      }else if(userInfo.ledCustomerAccountNo){
        this.form.buyingCustomerNo = userInfo.ledCustomerAccountNo
        this.form.buyingCustomerName = userInfo.ledCustomerAccountName || ''
      }
    },
    /* 组装提交参数，taxRate 不与后端交互 */
    buildPayload(){
      let products = this.productList.map(item=>{
        let product = { ...item }
        delete product.taxRate
        return product
      })
      return {
        ...this.form,
        productList:products
      }
    },
    /* 打开 End Customer 选择弹窗；传入当前已选值(form.endCustomerId 即 endCustomerCode)供自动勾选，并带入 Ordering Customer Name 显示在信息行 */
    showEndCustomer(){
      this.$refs.EndCustomer.open(this.form.endCustomerId, this.form.buyingCustomerName)
    },
    /* End Customer 弹窗选择回调：回填本页两个字段（弹窗 endCustomerCode→本页 endCustomerId，endCustomerName→endCustomerName） */
    getEndCustomerFromDialog(item){
      this.form.endCustomerId = item.endCustomerCode || ''
      this.form.endCustomerName = item.endCustomerName || ''
      //End Customer No. 为必填项，选完清掉可能存在的校验错误提示
      this.$nextTick(()=>{
        if(this.$refs.formGeneral){
          this.$refs.formGeneral.clearValidate('endCustomerId')
        }
      })
    },
    /* 提交保存：新增走 saveDraft、编辑走 updateHead（均 POST）；校验通过后组装 buildPayload() 再提交 */
    handleSubmit(){
      this.$refs.formGeneral.validate((valid)=>{
        if(!valid){
          return
        }
        let params = this.buildPayload()
        if(this.isNew){
          this.saveNew(params)
        }else{
          this.saveUpdate(params)
        }
      })
    },
    /* 新增保存：POST api_opp_new_head(saveDraft) → 后端返回的 data 即商机编号 oppNo →
       拿 oppNo 请求 api_opp_detail_head(GET) 回填表头 → 更新 oppId 与路由，切到编辑态 */
    saveNew(params){
      this.allLoading = true
      postAction(api_opp_new_head, params).then(res=>{
        //postAction 已把 responseData.data 作为 resolve 值；该 data 即商机编号（兼容后端返回 {oppNo} 对象的情况）
        let oppNo = (res && typeof res === 'object') ? (res.oppNo || '') : (res || '')
        if(!oppNo){
          this.allLoading = false
          this.$message.error('Failed to create opportunity.')
          return
        }
        //查询详情(GET，参数 oppNo)回填表头与产品列表（taxRate 在 fillForm 里统一写死 13）
        this.getDetail(oppNo).then(()=>{
          this.form.oppNo = oppNo
          this.oppId = oppNo //切到编辑态：isNew→false，标题/上传按钮/产品可编辑随之生效
          //更新路由 /opportunityDetail/New → /opportunityDetail/{oppNo}；replace 避免回退到已失效的新增态
          this.$router.replace({
            name:'OpportunityDetail',
            params:{ id: oppNo },
            query:{ ...this.$route.query }
          }).catch(()=>{})
          this.allLoading = false
          this.$message.success(this.L.operateSuccess)
        }).catch(()=>{
          this.allLoading = false
        })
      }).catch(()=>{
        this.allLoading = false
      })
    },
    /* 编辑保存：POST api_opp_update_head(updateHead) */
    saveUpdate(params){
      this.allLoading = true
      postAction(api_opp_update_head, params).then(()=>{
        this.allLoading = false
        this.$message.success(this.L.operateSuccess)
      }).catch(()=>{
        this.allLoading = false
      })
    },
    /* 查询商机详情：GET api_opp_detail_head，参数 oppNo；回填后 resolve 详情数据 */
    getDetail(oppNo){
      this.allLoading = true
      return getAction(api_opp_detail_head, { oppNo: oppNo }).then(detail=>{
        this.fillForm(detail)
        return detail
      })
      .finally(()=>{
        this.allLoading = false
      })
    },
    /* 用后端详情回填表单：表头字段按 this.form 的 key 逐个从 data 拷贝（后端未返回的保持原值）；
       产品列表用 data.productList 覆盖本地；taxRate 仅前端展示、后端不返回，统一写死 13 */
    fillForm(data){
      if(!data){
        return
      }
      Object.keys(this.form).forEach(key=>{
        if(data[key] !== undefined){
          this.form[key] = data[key]
        }
      })
      if(Array.isArray(data.productList)){
        this.productList = data.productList.map(item=>({ ...item, taxRate:13 }))
      }
    },
    /* 测量固定头部 .head-wrap 高度，并计算 General 区固定高与标题栏高（参考商机列表页 handleResize） */
    handleResize(){
      this.$nextTick(()=>{
        //固定头部高（供吸顶 top 与可用高计算）
        let headEl = document.querySelector('.head-wrap')
        this.headHeight = headEl ? headEl.offsetHeight : 0
        //本页吸顶头（导航+标题+面包屑）高
        let stickyEl = this.$refs.stickyHead
        let stickyH = stickyEl ? stickyEl.offsetHeight : 0
        //左侧分区标题栏高，用于右侧附件标题栏等高（仅在可见时更新，避免 product 页量到 0）
        let lineTitleEl = this.$refs.lineTitle
        if(lineTitleEl && lineTitleEl.offsetHeight){
          this.titleBarHeight = lineTitleEl.offsetHeight
        }
        //.general-data-wrap 可用高 = 视口高 − 固定头部 − 吸顶头 − 上下外边距(14+10) − 缓冲(6)（底部 margin-bottom 由 40 收到 10，常量随之 60→30，卡片底部留白 46px→16px；须与 index.less 的 .opportunity-detail margin-bottom 同步）
        let h = window.innerHeight - this.headHeight - stickyH - 30
        this.contentHeight = h > 200 ? h : 200
      })
    },
    /* 切换分区：更新 activeTab 并同步到路由 query.tab（用 replace 避免产生多余历史记录） */
    switchTab(tab){
      if(this.activeTab === tab){
        return
      }
      this.activeTab = tab
      this.$router.replace({ query: { ...this.$route.query, tab } }).catch(()=>{})
      //切回 general 时重新测量（隐藏时 offsetHeight 为 0，需显示后再量）
      if(tab === 'general'){
        this.handleResize()
      }
    },
    /* 从路由 query.tab 读取当前分区：
       general/product 直接切换；产品详情 key(opportunityLineId) 若页签已存在则切过去，
       否则先在 productList 里找对应产品复原页签，都找不到时仅占位（待 getDetail 加载完 productList 后由 restoreProductTabFromRoute 复原）。 */
    syncTabFromRoute(){
      let tab = this.$route.query.tab
      if(tab === 'general' || tab === 'product'){
        this.activeTab = tab
        return
      }
      if(tab){
        let exist = this.productTabs.find(t => t.key === tab)
        if(exist){
          this.activeTab = tab
          return
        }
        let product = this.productList.find(item => String(item.opportunityLineId) === tab)
        if(product){
          this.openProductDetail(product)
          return
        }
        this.activeTab = tab
      }else{
        this.activeTab = 'general'
      }
    },
    /* 详情加载完（productList 就绪）后复原路由 query.tab 指向的产品详情页签：
       new_ 前缀的未保存新增产品按原 key 复原一个空内容页签（内容为空可接受，但页签必须保留）；
       真实 opportunityLineId 在 productList 里找到则打开，找不到（已删除）时回退到 Product List。 */
    restoreProductTabFromRoute(){
      let tab = this.$route.query.tab
      if(!tab || tab === 'general' || tab === 'product'){
        return
      }
      if(this.productTabs.find(t => t.key === tab)){
        this.activeTab = tab
        return
      }
      //未保存的新增产品（临时 key）：刷新后 productList 里没有它，按原 key 复原空页签，不要把 tab 去掉
      if(tab.indexOf('new_') === 0){
        this.productTabs.push({
          key: tab,
          label: 'New Product',
          data: {}
        })
        this.activeTab = tab
        return
      }
      let product = this.productList.find(item => String(item.opportunityLineId) === tab)
      if(product){
        this.openProductDetail(product)
      }else{
        this.switchTab('product')
      }
    },
    /* 面包屑页签显示文字：按 Model → EAN10 → Product Description(productName) → NPI Description(npiDesc) 顺序取第一个有值的；都无值时回退 'New Product' */
    getProductTabLabel(row){
      let r = row || {}
      return r.model || r.ean || r.productName || r.npiDesc || 'New Product'
    },
    /* 打开产品详情（替代原 ProductDialog）：由 ProductList 的 Edit/New Item 触发（@open-detail）。
       key 以 opportunityLineId 为唯一标识（新增无 id 时用临时 key）；label 按 getProductTabLabel 的顺序取值。
       同一产品重复点击时不新建页签，直接切到已存在的页签。产品标识写入路由 query.tab，刷新后可复原到当前产品详情。 */
    openProductDetail(product){
      let row = product || {}
      let key = row.opportunityLineId ? String(row.opportunityLineId) : ('new_' + Date.now())
      let exist = this.productTabs.find(t => t.key === key)
      if(exist){
        exist.data = { ...row }
        exist.label = this.getProductTabLabel(row)
      }else{
        this.productTabs.push({
          key,
          label: this.getProductTabLabel(row),
          data: { ...row }
        })
      }
      this.activeTab = key
      //把产品标识写入路由 query.tab（replace 避免多余历史记录），刷新页面时据此复原当前产品详情页签
      this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(()=>{})
    },
    /* 关闭产品详情页签：从列表移除；若关闭的正是当前页签，则切回 Product List */
    closeProductTab(key){
      let idx = this.productTabs.findIndex(t => t.key === key)
      if(idx === -1){
        return
      }
      this.productTabs.splice(idx, 1)
      if(this.activeTab === key){
        this.switchTab('product')
      }
    },
    /* 切到指定产品详情页签：更新 activeTab 并同步到路由 query.tab */
    switchToProductTab(key){
      if(this.activeTab === key){
        return
      }
      this.activeTab = key
      this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(()=>{})
    },
    /* 拉取产品列表：GET api_opp_case_product_list，oppNo 作为 URL query 参数（不动表头、不影响当前页签）；taxRate 仅前端展示，统一写死 13 */
    getProductList(){
      if(this.isNew || !this.oppId){
        return Promise.resolve()
      }
      this.allLoading = true
      return getAction(api_opp_case_product_list, { oppNo: this.oppId }).then(res=>{
        this.allLoading = false
        this.productList = res
      }).catch(()=>{
        this.allLoading = false
      })
    },
    /* 产品详情保存成功：同步刷新该页签的显示文字（新增保存后才有 Model/EAN10 等值），并刷新产品列表，保留当前页签 */
    onProductSaved(tab, savedForm){
      if(tab && savedForm){
        tab.label = this.getProductTabLabel(savedForm)
      }
      this.getProductList()
    },
    /* 产品详情删除成功：关闭对应页签并刷新产品列表 */
    onProductDeleted(tab){
      if(tab){
        this.closeProductTab(tab.key)
      }
      this.getProductList()
    }
  },
  created(){
    this.getOppSelect()
    this.oppId = this.$route.params.id || ''
    this.syncTabFromRoute()
    if(this.isNew){
      this.setNewDefault()
    }else{
      //先拉表头详情，再拉产品列表（专用列表接口），完成后据路由 query.tab 复原可能停留的产品详情页签
      this.getDetail(this.oppId).then(()=>{
        return this.getProductList()
      }).then(()=>{
        this.restoreProductTabFromRoute()
      })
      this.getFileList()
    }
  },
  mounted(){
    //头部/吸顶头高度可能因图片加载/响应式换行变化，多处测量保证吸顶 top 与可用高准确
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('load', this.handleResize)
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('load', this.handleResize)
  }
}
</script>

<style lang="less" scoped>
@import url('/public/css/public.less');
@import url('./index.less');
</style>

<style lang="less">
/* 下拉弹层选项（挂到 body，scoped 无法命中，用 popper-class 命名空间限定只影响本页下拉），字体/字号参考 cqm2 public.less .el-select-dropdown__item */
.opp-select-popper .el-select-dropdown__item{
  font-size:13px;
  color:#606266;
  height:34px;
  line-height:34px;
  padding:0 8px;
  font-family:apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", Helvetica, "PingFang SC", "Meiryo UI", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;
}
</style>
